/**
 * 添加自定义的store的Getter，要先保证添加了需要的模块，sample为例子，使用时可删除
 * 目的是快速使用store中存储的状态，参见https://vuex.vuejs.org/zh/guide/getters.html
 * 并可使用mapGetters混入具体组件的computed对象中
 *
 */
const getters = {
  sampleValue: state => state.sample.value
}

export default getters

